import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { BiTrip } from "react-icons/bi";
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { IoIosCash } from "react-icons/io";

const BASE_URL = `${window.location.origin}`;
const storedUserDetails = localStorage.getItem("userdetails");
const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
const userRole = userDetails ? userDetails.role.toLowerCase() : null;
const companiesId = userDetails ? userDetails.companies_id : null; 
const roleFeaturesRaw = localStorage.getItem('roleFeatures');
const roleFeatures = roleFeaturesRaw ? JSON.parse(roleFeaturesRaw) : null;
const navFeatures = (roleFeatures && Array.isArray(roleFeatures.nav)) ? roleFeatures.nav : [];
const visibleFeatures = (roleFeatures && Array.isArray(roleFeatures.visible)) ? roleFeatures.visible : [];

export const FinalSidebarData = [
  { title: 'Dashboard', path: '' + BASE_URL + '/dashboard', icon: <AiIcons.AiFillHome />, cName: 'nav-text' },
  { title: 'Orders', path: '' + BASE_URL + '/orders', icon: <FaIcons.FaFileUpload />, cName: 'nav-text' },
  { title: 'Trips', path: '' + BASE_URL + '/trips', icon: <BiTrip />, cName: 'nav-text' },
  { title: 'Devices', path: '' + BASE_URL + '/devices', icon: <GpsFixedIcon />, cName: 'nav-text' },
  { title: 'Stops', path: '' + BASE_URL + '/stops', icon: <FaIcons.FaMapMarkerAlt />, cName: 'nav-text' },
  { title: 'Billing', path: '' + BASE_URL + '/billing', icon: <IoIosCash />, cName: 'nav-text' },
  { title: 'Vehicles', path: '' + BASE_URL + '/vehicles', icon: <FaIcons.FaCarAlt />, cName: 'nav-text' },
  { title: 'Drivers', path: '' + BASE_URL + '/drivers', icon: <FaIcons.FaUser />, cName: 'nav-text' },
  { title: 'Earnings', path: '' + BASE_URL + '/earnings', icon: <IoIosCash />, cName: 'nav-text' },
  { 
    title: 'Offers', 
    path: '/offers', 
    icon: <FaIcons.FaGift />, 
    cName: 'nav-text',
    target: (userRole === 'platform_tech' || userRole === 'platform_ops' || userRole === 'platform_finance') ? '_blank' : '_self',
    rel: (userRole === 'platform_tech' || userRole === 'platform_ops' || userRole === 'platform_finance') ? 'noopener noreferrer' : undefined
  },
  { title: 'Reports', path: '/reports', icon: <IoIcons.IoIosPaper />, cName: 'nav-text' },
  { title: 'Whatsapp', path: '', icon: <FaIcons.FaWhatsapp />, cName: 'nav-text' },
  { title: 'Companies', path: '' + BASE_URL + '/company', icon: <CorporateFareIcon/>, cName: 'nav-text' },
  { title: 'Institutions', path: '' + BASE_URL + '/institutions', icon: <CorporateFareIcon/>, cName: 'nav-text' },
  { title: 'Clients', path: '' + BASE_URL + '/clients', icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />, cName: 'nav-text' },
  { title: 'Vendors', path: '' + BASE_URL + '/vendors', icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />, cName: 'nav-text' },
  { title: 'Warehouses', path: '' + BASE_URL + '/warehouses', icon: <FaIcons.FaWarehouse style={{ color: 'white', scale: '0.9' }} />, cName: 'nav-text' },
  { title: 'Users', path: '' + BASE_URL + '/users', icon: <FaIcons.FaUserShield style={{ color: 'white' }} />, cName: 'nav-text' },
];

const getVendorCompanyAdminSidebar = () => {
  const adminFeatures = {
    title: 'Admin Features',
    icon: <FaIcons.FaUserTie />,
    cName: 'nav-text',
    subNav: [
      { title: 'Clients', path: '' + BASE_URL + '/clients', icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />, cName: 'nav-text' },
      { title: 'Warehouses', path: '' + BASE_URL + '/warehouses', icon: <FaIcons.FaWarehouse style={{ color: 'white',scale: '0.9' }} />, cName: 'nav-text' },
      { title: 'Users', path: '' + BASE_URL + '/users', icon: <FaIcons.FaUserShield style={{ color: 'white' }} />, cName: 'nav-text' }
    ]
  };

  return FinalSidebarData.filter(item =>
    !['Companies', 'Institutions', 'Clients', 'Warehouses', 'Users', 'Vendors', 'Devices', 'Stops', 'Billing'].includes(item.title)
  ).concat([adminFeatures]);
};

const getClientCompanyAdminSidebar = () => {
  const adminFeatures = {
    title: 'Admin Features',
    icon: <FaIcons.FaUserTie />,
    cName: 'nav-text',
    subNav: [
      { title: 'Vendors', path: '' + BASE_URL + '/vendors', icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} />, cName: 'nav-text' },
      { title: 'Warehouses', path: '' + BASE_URL + '/warehouses', icon: <FaIcons.FaWarehouse style={{ color: 'white', scale:'0.9' }} />, cName: 'nav-text' },
      { title: 'Users', path: '' + BASE_URL + '/users', icon: <FaIcons.FaUserShield style={{ color: 'white' }} />, cName: 'nav-text' }
    ]
  };

  return FinalSidebarData.filter(item =>
    ![ 'Clients', 'Vendors', 'Warehouses', 'Users', 'Companies', 'Institutions', 'Devices', 'Stops', 'Billing'].includes(item.title)
  ).concat([adminFeatures]);
};

const desiredOrder = [
  'Dashboard',
  'Trips',
  'Companies',
  'Vehicles',
  'Devices',
  'Stops',
  'Billing',
  'Drivers',
  'Orders',
  'Reports',
  'Admin',           
  'Admin Features'   
];

const sortSidebarData = (data) => {
  return data.sort((a, b) => {
    const indexA = desiredOrder.indexOf(a.title);
    const indexB = desiredOrder.indexOf(b.title);

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return 0;
  });
};

const filteredSidebarData = (() => {
  if (navFeatures.length > 0 || visibleFeatures.length > 0) {
    const featureItemMap = {
      dashboard: { title: 'Dashboard', path: '' + BASE_URL + '/dashboard', icon: <AiIcons.AiFillHome /> },
      trips: { title: 'Trips', path: '' + BASE_URL + '/trips', icon: <BiTrip /> },
      orders: { title: 'Orders', path: '' + BASE_URL + '/orders', icon: <FaIcons.FaFileUpload /> },
      vehicles: { title: 'Vehicles', path: '' + BASE_URL + '/vehicles', icon: <FaIcons.FaCarAlt /> },
      reports: { title: 'Reports', path: '/reports', icon: <IoIcons.IoIosPaper /> },
      offers: { title: 'Offers', path: '/offers', icon: <FaIcons.FaGift /> },
      companies: { title: 'Companies', path: '' + BASE_URL + '/company', icon: <CorporateFareIcon/> },
      warehouses: { title: 'Warehouses', path: '' + BASE_URL + '/warehouses', icon: <FaIcons.FaWarehouse style={{ color: 'white', scale: '0.9' }} /> },
      clients: { title: 'Clients', path: '' + BASE_URL + '/clients', icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} /> },
      vendors: { title: 'Vendors', path: '' + BASE_URL + '/vendors', icon: <IoIcons.IoIosPeople style={{ color: 'white', scale: '1.5' }} /> },
      users: { title: 'Users', path: '' + BASE_URL + '/users', icon: <FaIcons.FaUserShield style={{ color: 'white' }} /> },
      earnings: { title: 'Earnings', path: '' + BASE_URL + '/earnings', icon: <IoIosCash /> },
      billing: { title: 'Billing', path: '' + BASE_URL + '/billing', icon: <IoIosCash /> },
      devices: { title: 'Devices', path: '' + BASE_URL + '/devices', icon: <GpsFixedIcon /> },
      geofenced_stops: { title: 'Stops', path: '' + BASE_URL + '/stops', icon: <FaIcons.FaMapMarkerAlt /> },
      drivers: { title: 'Drivers', path: '' + BASE_URL + '/drivers', icon: <FaIcons.FaUser /> },
      institutions: { title: 'Institutions', path: '' + BASE_URL + '/institutions', icon: <CorporateFareIcon/> },
      whatsapp: { title: 'Whatsapp', path: '', icon: <FaIcons.FaWhatsapp /> }
    };

    const addedTitles = new Set();
    const items = [];
    const adminKeys = ['clients', 'vendors', 'warehouses', 'users'];
    const adminSub = [];

    const allActiveFeatures = [...new Set([...navFeatures, ...visibleFeatures])];
    
    if (allActiveFeatures.some(f => f.toLowerCase().startsWith('dashboard'))) {
      if (!allActiveFeatures.includes('dashboard')) allActiveFeatures.push('dashboard');
    }
    
    if (allActiveFeatures.some(f => f.toLowerCase().startsWith('report'))) {
      if (!allActiveFeatures.includes('reports')) allActiveFeatures.push('reports');
    }
    if (allActiveFeatures.some(f => f.toLowerCase().startsWith('billing'))) {
      if (!allActiveFeatures.includes('billing')) allActiveFeatures.push('Billing');
    }
    if (allActiveFeatures.some(f => f.toLowerCase().startsWith('device'))) {
      if (!allActiveFeatures.includes('device')) allActiveFeatures.push('Devices');
    }
    
    allActiveFeatures.forEach((f) => {
      const lower = f.toLowerCase();
      const def = featureItemMap[lower];
      
      if (!def) return;
      
      if (lower === 'geofenced_stops' && userRole !== 'platform_tech') return;

      const isDisabled = visibleFeatures.includes(lower) && !navFeatures.includes(lower);

      if (adminKeys.includes(lower)) {
        if (!addedTitles.has(def.title)) {
          adminSub.push({ ...def, cName: 'nav-text', disabled: isDisabled });
          addedTitles.add(def.title);
        }
        return;
      }

      if (addedTitles.has(def.title)) return;

      const item = { ...def, cName: 'nav-text', disabled: isDisabled };

      if (lower === 'offers') {
        item.target = (userRole === 'platform_tech' || userRole === 'platform_ops' || userRole === 'platform_finance') ? '_blank' : '_self';
        item.rel = item.target === '_blank' ? 'noopener noreferrer' : undefined;
      }

      items.push(item);
      addedTitles.add(def.title);
    });

    const isCompanyAdmin = userRole === 'vendor_company_admin' || userRole === 'client_company_admin';
    const shouldShowAdmin = (companiesId == 1) || isCompanyAdmin;

    if (adminSub.length > 0 && shouldShowAdmin) {
      const allSubDisabled = adminSub.every(sub => sub.disabled === true);
      items.push({ 
        title: 'Admin', 
        icon: <FaIcons.FaUserTie />, 
        cName: 'nav-text', 
        disabled: allSubDisabled, 
        subNav: adminSub 
      });
    }

    return sortSidebarData(items); 
  }
  
  if (userRole === 'platform_tech' || userRole === 'platform_ops' || userRole === 'platform_finance') {
    let allowedTitles = [];
    if (companiesId != 1) {
      allowedTitles = ['Companies', 'Offers', 'Vehicles', 'Devices', 'Institutions', 'Billing'];
    } else {
      allowedTitles = ['Companies', 'Offers', 'Devices', 'Billing'];
    }

    if (userRole === 'platform_tech' && (navFeatures.includes('geofenced_stops') || visibleFeatures.includes('geofenced_stops'))) {
      allowedTitles.push('Stops');
    }

    return sortSidebarData(FinalSidebarData.filter(item => allowedTitles.includes(item.title)));
  }

  let data = [];
  switch(userRole) {
    case 'vendor_supervisor':
      data = FinalSidebarData.filter(item =>
        !['Companies', 'Institutions', 'Vendors', 'Users', 'Devices', 'Stops', 'Billing'].includes(item.title)
      );
      break;
    case 'client_supervisor':
      data = FinalSidebarData.filter(item =>
        !['Companies', 'Institutions', 'Clients', 'Warehouses', 'Users', 'Devices', 'Stops', 'Billing'].includes(item.title)
      );
      break;
    case 'vendor_company_admin':
      data = getVendorCompanyAdminSidebar();
      break;
    case 'client_company_admin':
      data = getClientCompanyAdminSidebar();
      break;
    default:
      data = FinalSidebarData.filter(item =>
        !['Offers', 'Devices', 'Stops', 'Billing'].includes(item.title)
      );
      break;
  }

  if (companiesId != 1) {
    const restrictedItems = ['Offers', 'Whatsapp', 'Earnings'];
    data = data.filter(item => !restrictedItems.includes(item.title));
  }

  if ((companiesId == 85 || companiesId == 10) && (userRole === 'client_company_admin' || userRole === 'client_supervisor')) {
    const disabledItems = ['Trips', 'Drivers', 'Orders', 'Admin', 'Vendors', 'Warehouses', 'Users'];
    data = data.map(item => ({
      ...item,
      disabled: disabledItems.includes(item.title)
    }));
  }

  return sortSidebarData(data); 
})();

export default filteredSidebarData;